module.exports = __webpack_public_path__ + "img/GR040.21e016e9.svg";